/** Прочерк для отсутствующей границы окна видимости (min/max === null). */
export const EMPTY_WINDOW_BOUNDARY = '—'

/**
 * Форматирует границу окна видимости студента.
 * `null`/`undefined` (граница отсутствует) → «—», иначе — дата в ru-RU.
 * Раньше пустое значение коэрсилось в `new Date(null)` = эпоха и показывалось как 01.01.1970.
 */
export const formatWindowDate = (value: null | number | undefined): string => {
  if (value === null || value === undefined) {
    return EMPTY_WINDOW_BOUNDARY
  }

  return new Date(value).toLocaleDateString('ru-RU')
}

const hasBoundary = (value: null | number | undefined): value is number =>
  value !== null && value !== undefined

/**
 * Человекочитаемое описание окна видимости для тултипа.
 * Отсутствующие границы (null) описываются словами, а не прочерком:
 * - обе отсутствуют → «без ограничений»
 * - нет нижней → «без нижней границы — 30.05.2026»
 * - нет верхней → «20.05.2026 — без верхней границы»
 * - обе заданы → «20.05.2026 — 30.05.2026»
 */
export const formatWindowRange = (
  min: null | number | undefined,
  max: null | number | undefined
): string => {
  const hasMin = hasBoundary(min)
  const hasMax = hasBoundary(max)

  if (!hasMin && !hasMax) {
    return 'без ограничений'
  }

  const minLabel = hasMin ? formatWindowDate(min) : 'без нижней границы'
  const maxLabel = hasMax ? formatWindowDate(max) : 'без верхней границы'

  return `${minLabel} — ${maxLabel}`
}
